import type { ReactNode } from 'react';
import { Enlace1, Enlace2, Enlace3, SupportLine } from './wallet-links';

function IntroCopy(): ReactNode {
  return (
    <div className="space-y-sm">
      <p>
        Si ya tienes una billetera de USDC y conectada con tu tarjeta de crédito
        para poder usar ese dinero en el día a día, puedes saltarte este vídeo.
      </p>
      <p>
        Si no, te recomiendo que lo veas con atención. No es solo un tutorial:
        es una clase sobre dinero que te va a ayudar en tu futuro, además de
        enseñarte a crear tu propia billetera para recibir USDC y luego usar ese
        dinero en tu día a día (incluso con tarjeta).
      </p>
      <p>Es muy simple. Solo necesitas entenderlo una vez.</p>
    </div>
  );
}

export function WalletInfo(): ReactNode {
  return (
    <div className="space-y-lg text-sm text-text-secondary">
      <IntroCopy />
      <Enlace1 />
      <Enlace2 />
      <Enlace3 />
      <SupportLine />
    </div>
  );
}
